import { Tabbar, TabbarItem, Button,List,RadioGroup, Radio,Checkbox, CheckboxGroup,Tab, Tabs,DropdownMenu, DropdownItem,NoticeBar,CountDown,Uploader   } from 'vant'
let vantUIs = [Tabbar, TabbarItem, Button,List,RadioGroup, Radio,Checkbox, CheckboxGroup,Tab, Tabs,DropdownMenu, DropdownItem,NoticeBar,CountDown,Uploader ]
export default {
  install (Vue) {
    vantUIs.forEach(vantUI => {
      // console.log(vantUI.name)
      Vue.component(vantUI.name, vantUI)
    // Vue.use(vantUI)    // 也可以使用 Vue.use()
    })
  }
}


//////////////////
// WEBPACK FOOTER
// ./components/vant.js
// module id = null
// module chunks = 